import React from 'react';
import { Dialog } from 'primereact/dialog';
import UploadDocumento from './UploadDocumento'; // Importa el componente de carga de documentos

const UploadDocumentoModal = ({ isOpen, onClose, idContenedor, language }) => {
  const header = `Subir Documento para Contenedor: ${idContenedor}`;

  return (
    <Dialog
      header={header}
      visible={isOpen}
      modal
      style={{ width: '50vw' }}
      onHide={onClose}
      draggable={false}
      resizable={false}
    >
      <UploadDocumento
        idReferencia={idContenedor} // Pasa el IdContenedor como idReferencia
        language={language}
        onUploadSuccess={onClose} // Cierra el modal al subir exitosamente
      />
    </Dialog>
  );
};

export default UploadDocumentoModal;